// generated by genversion
export const version = '4.7.5';



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = ./src/version.js
// module chunks = main